<template>
  <div class="color">
    <ColorPicker
      :value="letterNumberArtwork.color"
      :colors="colors"
      show-color-label
      @change="handleSelect"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import ColorPicker from "components/jiffy/vue-product-details-dtf/ColorPicker.vue";
import { useDtfStore } from "../store";

const colors = [
  { name: "Black", value: "#000000" },
  { name: "White", value: "#FFFFFF" },
  { name: "Navy", value: "#03283A" },
  { name: "Red", value: "#D50132" },
  { name: "Gold", value: "#FCA311" },
  { name: "Green", value: "#016B3F" },
  { name: "Purple", value: "#514689" },
  { name: "Royal", value: "#082D99" },
  { name: "Gray", value: "#82878D" },
  { name: "Columbia", value: "#6887B7" },
  { name: "Orange", value: "#F14329" },
  { name: "Vegas Gold", value: "#ABA275" },
  { name: "Yellow", value: "#F8DC02" }
];

const store = useDtfStore();
const letterNumberArtwork = computed(() => store.letterNumberArtwork);

const handleSelect = color => {
  store.updateArtworkValues({ index: 0, color });
  store.generateLettersPreview();
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.color {
  position: relative;

  .color-picker__modal {
    @include with-tablet {
      top: auto;
      left: auto;
      margin-left: unset;
    }
  }
}
</style>
